import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden bg-bone-100"
    >
      <div aria-hidden className="absolute top-32 -left-24 w-[420px] h-[420px] rounded-full bg-sage-200/50 blur-3xl" />
      <div aria-hidden className="absolute top-60 right-0 w-[320px] h-[320px] rounded-full bg-clay-200/40 blur-3xl" />

      <div className="relative max-w-6xl mx-auto px-6 lg:px-10 text-center">
        <span className="inline-flex items-center gap-2 px-4 h-9 rounded-full bg-bone-50 border border-bone-300 font-mono-fine text-[11px] tracking-[0.22em] uppercase text-sage-600">
          <span className="w-1.5 h-1.5 rounded-full bg-sage-500" />
          Balance · Körper &amp; Finanzen
        </span>

        <h1 className="mt-8 font-display font-light text-[2.8rem] sm:text-[4rem] lg:text-[5.5rem] leading-[0.96] tracking-[-0.035em] text-ink-900 max-w-5xl mx-auto">
          Klarheit für deine{" "}
          <span className="italic font-normal text-sage-500">Gesundheit</span>
          {" "}und deine{" "}
          <span className="italic font-normal text-clay-500">Finanzen</span>.
        </h1>

        <p className="mt-8 max-w-2xl mx-auto text-ink-700 text-[17px] leading-relaxed">
          Verstehe deinen Körper besser und gestalte deine Finanzen bewusst. Zwei Bereiche, die enger zusammenhängen, als den meisten bewusst ist und die zusammen deinen Alltag stabiler, leichter und planbarer machen.
        </p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/kontakt"
            data-testid="hero-cta-primary"
            className="group inline-flex items-center gap-3 pl-7 pr-2 h-14 rounded-full bg-sage-500 hover:bg-sage-600 text-bone-50 text-[14px] tracking-wide transition-all duration-300 hover:-translate-y-0.5 shadow-soft"
          >
            Kostenloses Erstgespräch
            <span className="w-11 h-11 rounded-full bg-honey-400 text-ink-900 flex items-center justify-center transition-transform duration-500 group-hover:rotate-45">
              <ArrowUpRight strokeWidth={1.75} className="w-4 h-4" />
            </span>
          </Link>
          <a
            href="#leistungen"
            data-testid="hero-cta-secondary"
            className="inline-flex items-center gap-2 px-6 h-12 rounded-full border border-ink-900/20 hover:border-ink-900 text-ink-900 text-[13px] tracking-wide transition-colors"
          >
            Mehr erfahren
          </a>
        </div>
      </div>

      {/* Hero image */}
      <div className="relative max-w-6xl mx-auto px-6 lg:px-10 mt-16 md:mt-20">
        <div className="relative overflow-hidden rounded-[2rem] md:rounded-[2.5rem] border border-bone-300 shadow-lift">
          <img
            src="https://static.prod-images.emergentagent.com/jobs/95c0696e-38c6-4b0c-80e9-86ee9a68795b/images/3f73ce7006ca16f0f9bf2d7e787ecd9d34ec64097c5d5f0d1ed89db87f5caf03.png"
            alt="Gesundheit und Finanzen im Gleichgewicht"
            data-testid="hero-image"
            className="w-full h-[300px] md:h-[440px] lg:h-[520px] object-cover reveal-up"
          />
          <div className="absolute right-6 top-6 md:right-10 md:top-10 flex items-center gap-2 px-4 h-10 rounded-full bg-honey-400 text-ink-900 font-mono-fine text-[11px] tracking-[0.18em] uppercase shadow-soft">
            <Sparkles strokeWidth={1.75} className="w-3.5 h-3.5" />
            Medical Medium · DVAG
          </div>
        </div>
      </div>
    </section>
  );
}
